import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventScheduleFlight {
	immigDivi: string;
	naCd: string;
	cityCd: string;
	sortOrder: number;
	cityKorNm: string;
}

/** ```
 * 비행 경유지 조회
 *   `/pkg/event-schedule/{evCd}/flight`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const key = "useEventScheduleFlight";
const getPath = (evCd: string): string | null => {
	if (!evCd) return null;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-schedule/${evCd}/flight`;
};

/** ```
 * 비행 경유지 조회
 *   `/pkg/event-schedule/{evCd}/flight`
 * parameter
 *   `evCd` 행사코드
 * ```*/
const useEventScheduleFlight = (
	evCd: string,
	options?: Partial<UseQueryOptions<Response<EventScheduleFlight[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(evCd)],
		queryFn: () => useConfigureAxios({url: getPath(evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});
export default useEventScheduleFlight;
export {getPath};
export type {EventScheduleFlight};
